import { React, useEffect, useState } from 'react';
import NavigationUser from '../../common/navigationUser/NavigationUser';
import style from './standView.module.scss';
import { useHistory, useParams } from 'react-router';
import axios from './../../../config/apiConfig';
import {
  InstagramOutlined,
  GlobalOutlined,
  FacebookOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons';
import Navegation from '../../common/navegationHome/Navegation';
import { CustomButton, LoadingTable } from '../../utils/Utils';
import { RightCircleFilled, LeftCircleFilled } from '@ant-design/icons';
import smallStand from './../../../img/Stand_SmallT.png';
import mediumStand from './../../../img/Stand_MediumT.png';
import fullStand from './../../../img/Stand_FullT.png';
import Full from './Full';
import Medium from './Medium';
import Standard from './Standard';
import { SmallModal } from '../../utils/Modals';
import { Image } from 'antd';

const StandView = ({ setComboTriggered }) => {
  const {
    container,
    comboItem,
    roundBtnLabel,
    roundBtnSpan,
    standImg,
    loading,
    // endLoading
  } = style;
  const { id, hall } = useParams();
  const history = useHistory();

  const [hallType, setHallType] = useState('');
  const [combos, setCombos] = useState([]);
  const [stand, setStand] = useState([]);
  const [supNav, setSupNav] = useState(false);
  const [nextPrevStands, setNextPrevStands] = useState({});
  const [loadingPage, setLoadingPage] = useState(true);
  const [errorVisitShow, setErrorVisitShow] = useState(false);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role === 'supplier') {
      setSupNav(true);
    }
  }, []);

  useEffect(() => {
    if (stand.length !== 0) {
      const parsedStands = JSON.parse(localStorage.getItem('stands'));
      const currentStandId = stand._id;
      const pos = parsedStands.indexOf(currentStandId);
      setNextPrevStands({
        ...nextPrevStands,
        next: parsedStands[pos + 1] ? parsedStands[pos + 1] : '',
        prev: parsedStands[pos - 1] ? parsedStands[pos - 1] : '',
      });
    }
  }, [stand]);

  useEffect(async () => {
    try {
      const { data } = await axios.get(`/stands/${id}`);
      setStand(data.data[0]);
      setHallType(data.data[0].type);
      setCombos(data.data[0].combos);
      setLoadingPage(false);
    } catch {
      history.push('/');
    }
  }, []);

  useEffect(async () => {
    try {
      if (stand.length !== 0) {
        await axios.post('/visits',{stand: stand._id});
      }
    } catch {
      setErrorVisitShow(true);
    }
  }, [stand]);

  const displayCombos = (arr) => {
    const combos = arr.map((combo,i) => {
      if (combo.starred) {
        return (
          <div
            className={comboItem}
            key={i}
            onClick={() => {
              if(localStorage.getItem('role') === 'pharmacy'){
                setComboTriggered(combo);
              }
              history.push(`/${hall}/${id}/combos`);
            }}
          >
            <div>
              <b>Combo {combo.name}</b>
            </div>
            <div>{`(${combo.products.length} articulos)`}</div>
          </div>
        );
      }
    });
    return combos;
  };

  const makeEmbedLink = (link) => {
    const findV = link.indexOf('v=');
    const findEmbed = link.indexOf('embed');
    if (findV === -1 ) {
      if (findEmbed === -1) {
        const id = link.split('youtu.be/');
        return id[1];
      } else {
        const id = link.split('embed/');
        return id[1];
      }
    }
    const id = link.split('v=');
    const noOtherParamsVer = id[1].split('?');
    const noOtherParamsVer2 = noOtherParamsVer[0].split('&');
    return noOtherParamsVer2[0];
  };

  const toggleModal = (set, state) => {
    set(!state);
  };

  return (
    <>
      {loadingPage ? 
        <div className={loading}>
          <LoadingTable />
        </div>  
        :
        // <div className={endLoading}>
        <div>
        </div>
      }
      {supNav ? <Navegation /> : <NavigationUser brandSize="122px" />}
      <div className={container}>
        <div
          className="displayStands_changeStands"
          style={{ width: '80%', height: 'calc((100vh - 89px) * 0.81)' }}
        >
          {nextPrevStands.next !== '' ? (
            <div className="displayStands_chStandsArrow">
              <RightCircleFilled
                onClick={() => {
                  history.push(`/${hall}/${nextPrevStands.next}`);
                  window.location.reload();
                }}
              />
            </div>
          ) : (
            <div className="displayStands_chStandsArrow"></div>
          )}

          {nextPrevStands.prev !== '' && (
            <div className="displayStands_chStandsArrow">
              <LeftCircleFilled
                onClick={() => {
                  history.push(`/${hall}/${nextPrevStands.prev}`);
                  window.location.reload();
                }}
              />
            </div>
          )}
        </div>
        <div>
          <div>
            <div>
              {hallType === 'standard' && (
                <div style={{backgroundColor: 'white'}}>
                  <Image preview={false} className={standImg} alt="" src={smallStand} />
                  <Standard makeEmbedLink={makeEmbedLink} stand={stand}/>
                </div>
              )}
              {hallType === 'intermediate' && (
                <div style={{backgroundColor: stand.standColor ? stand.standColor : 'white'}}>
                  <Image preview={false} className={standImg} alt="" src={mediumStand} />
                  <Medium makeEmbedLink={makeEmbedLink} stand={stand}/>
                </div>
              )}
              {hallType === 'full' && (
                <div style={{backgroundColor: stand.standColor ? stand.standColor : 'white'}}>
                  <Image preview={false} className={standImg} alt="" src={fullStand} />
                  <Full makeEmbedLink={makeEmbedLink} stand={stand}/>
                </div>
              )}

              
            </div>
          </div>
          <div>
            <div>
              {
                stand?.facebookLink &&
                <div>
                  <FacebookOutlined />
                  <a href={stand?.facebookLink} target="_blank" rel="noopener noreferrer">
                    { stand?.facebookLink.slice(12) }
                  </a>
                </div>
              }
              {
                stand?.instagramLink &&
                <div>
                  <InstagramOutlined />
                  <a href={stand?.instagramLink} target="_blank" rel="noopener noreferrer">
                    {stand?.instagramLink.slice(12)}
                  </a>
                </div>
              }
              {
                stand?.webLink &&
                <div>
                  <GlobalOutlined />
                  <a href={stand?.webLink} target="_blank" rel="noopener noreferrer">
                    {stand?.webLink.slice(8)}
                  </a>
                </div>
              }
            </div>
            <div>
              <a
                target="_blank"
                href={'https://wa.me/+5493816202489'}
                rel='noreferrer'
              >
                <div className={roundBtnSpan}>
                  <WhatsAppOutlined />
                </div>
                <div className={roundBtnLabel}>Chatea con nosotros</div>
              </a>
            </div>
          </div>
        </div>
        <div>
          <h2>Nuestros Combos</h2>
          {combos && displayCombos(combos)}
          <div>
            <CustomButton
              content="Ver más combos"
              color="btnPrimary"
              size="bg"
              onclick={() => history.push(`/${hall}/${id}/combos`)}
            />
          </div>
        </div>
      </div>

      <SmallModal
        title="Ocurrió un error inesperado recargue la página si el error persiste vuelva al hall de entrada por favor"
        toggle={toggleModal}
        state={errorVisitShow}
        set={setErrorVisitShow}
        howManyBtn="2"
        zIndex='2'
        reload={true}
        firstBtn={{
          color: 'btnOrange',
          content: 'Recargar página',
          onclick: () => window.location.reload(),
        }}
        secondBtn={{
          color: 'btnOutline',
          content: 'Volver al hall',
          onclick: () => history.push(`/${hall}`)
        }}
      />
    </>
  );
};

export default StandView;
